const configuratorPromotion = {
    emptyPromotionData: function () {
        return {
            title: '',
            details: '',
            image: '',
            heading: 'offer'
        };
    },
    getPromotionDataFromCard: function ($card) {
        var data = this.emptyPromotionData();
        var $warrantyItem = $card.closest('.pdp-warranty-extras__item');

        if ($warrantyItem.length) {
            data.heading = 'warranty';
            data.title = $warrantyItem.find('.promotions-info').first().text().trim();
            data.details = $warrantyItem.find('.promotions-info-details').html() || '';
            return data;
        }

        var $details = $card.find('.promotions-info-details');

        data.title = $card.find('.promotions-info').text().trim();
        data.details = $details.is('input') ? ($details.val() || '') : ($details.html() || '');
        data.image = $card.find('.promotion-image-logo')[0].outerHTML;

        return data;
    },
    resetPromotionDetailsModal: function () {
        var promotionModal = $('#promotion-details-modal');

        var $heading = promotionModal.find('.promotion-modal-heading');

        $heading.text($heading.data('offer-label') || '');
        promotionModal.find('.promotion-modal-info-header').text('');
        promotionModal.find('.promotion-modal-info-text').empty();
        promotionModal.find('.promotion-modal-image-container').empty();
    },
    openPromotionDetailsModal: function (data) {
        var promotionModal = $('#promotion-details-modal');
        var safeData = data || this.emptyPromotionData();
        var $heading = promotionModal.find('.promotion-modal-heading');
        var headingLabel = safeData.heading === 'warranty'
            ? $heading.data('warranty-label')
            : $heading.data('offer-label');

        this.resetPromotionDetailsModal();

        $heading.text(headingLabel || '');
        promotionModal.find('.promotion-modal-info-header').text(safeData.title || '');
        promotionModal.find('.promotion-modal-info-text').html(safeData.details || '');

        if (safeData.image) {
            promotionModal.find('.promotion-modal-image-container').html(safeData.image);
            promotionModal.addClass('has-image');
        } else {
            promotionModal.removeClass('has-image');
        }

        promotionModal.modal('show');
    },
    setupPromotionCardClick: function () {
        var getPromotionDataFromCard = this.getPromotionDataFromCard.bind(this);
        var openPromotionDetailsModal = this.openPromotionDetailsModal.bind(this);

        $(document).on('click', '.promotions-card', function (e) {
            var $card = $(this);

            if ($card.closest('.pdp-warranty-extras__item').length) {
                e.preventDefault();
            }

            openPromotionDetailsModal(getPromotionDataFromCard($card));
        });
    },
    init: function () {
        this.setupPromotionCardClick();
    }
};

module.exports = configuratorPromotion;
